import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  PaymentAccountStatus,
  PaymentAccountType,
} from '@portal/models/enumerators/paymentAccount';
import { PaymentAccount, User } from '@portal/models/module';
import { secondaryAccounts } from '@portal/config/app.json';

export const getPaymentAccountByType = (
  loggedUser: User,
  paymentAccountType: PaymentAccountType
) => {
  if (!loggedUser) {
    return;
  }

  return loggedUser.account.paymentAccounts.find(
    (paymentAccount: PaymentAccount) => {
      return paymentAccount.type === paymentAccountType;
    }
  );
};

export const formatPaymentAccountForSelect = (
  paymentAccount: PaymentAccount
) => ({
  value: paymentAccount.id,
  data: paymentAccount,
  name: paymentAccount.paymentAccountName,
});

export const getApprovedPaymentAccountsByTypeAsSelect = (
  loggedUser: User,
  paymentAccountType?: PaymentAccountType
) => {
  if (!loggedUser) {
    return [];
  }

  return getApprovedPaymentAccountsByType(loggedUser, paymentAccountType).map(
    (paymentAccount) => {
      const temp = formatPaymentAccountForSelect(paymentAccount);
      return temp;
    }
  );
};

export const getApprovedPaymentAccountsByType = (
  loggedUser: User,
  type?: PaymentAccountType
) => {
  if (!loggedUser) {
    return [];
  }

  const hasSecondaryAccount = loggedUser.account.paymentAccounts.find(
    (paymentAccount) =>
      paymentAccount.type === PaymentAccountType.ACCOUNTSECONDARY &&
      paymentAccount.status === PaymentAccountStatus.APPROVED
  );

  if (secondaryAccounts.enable && hasSecondaryAccount) {
    return loggedUser.account.paymentAccounts.filter(
      (paymentAccount) =>
        paymentAccount.status === PaymentAccountStatus.APPROVED &&
        (paymentAccount.type === PaymentAccountType.ACCOUNT ||
          paymentAccount.type === PaymentAccountType.ACCOUNTSECONDARY)
    );
  }

  if (type) {
    return loggedUser.account.paymentAccounts.filter(
      (paymentAccount) =>
        paymentAccount.type === type &&
        paymentAccount.status === PaymentAccountStatus.APPROVED
    );
  }

  return loggedUser.account.paymentAccounts;
};

export const createPaymentAccountName = (
  paymentAccount: PaymentAccount
): string => {
  const { bankAccount, bankBranchAccount, bankNumber } = paymentAccount;

  return (
    (bankAccount
      ? bankAccount + (bankBranchAccount ? '-' + bankBranchAccount : '')
      : '') + (bankNumber ? (bankAccount && ' / ') + bankNumber : '')
  );
};
